import {Component, OnInit, ViewChild} from '@angular/core';
import {PromotionsSModel} from '../../../../../components/parentchild/promotionsS/promotionsS.model';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService} from 'primeng/primeng';
import {LocalStorageService} from 'ng2-webstorage';
import {NgForm} from '@angular/forms';
import {ApprovalClassModel} from '../../../../../components/googleClassroom/googleClassroom.model';
import {AddStudentRcModel, rciModel} from '../../../../../components/dataAnalytics/dataAnalytics.model';
import {Router} from '@angular/router';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {AppConstants} from '../../../../../app.constants';
import * as html2pdf from "html2pdf.js"



@Component({
  selector: 'app-student-profile',
  templateUrl: './translate-papers.component.html',
  styleUrls: ['./translate-papers.component.css']
})

export class TranslatePapersComponent implements OnInit {
  @ViewChild('form') form : NgForm;
  selectedFile: File;
  selectStyle: string;
  public previwbtn: boolean = true;
  public printbtn: boolean = false;
  approvalClassModel = new ApprovalClassModel();
  addStudentRcModel = new AddStudentRcModel();
  rcimodel = new rciModel()
  // public data1: AddStudentRcModel[];
  public ReportsData: any = [];
  googleUser: any;
  studentList = [];
  courseId: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  studentRCData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: any;
  gclList: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  standardId: any = [];
  nameofstd: any = [];
  nameofsec: any = [];
  yearId: any = [];
  yearname: any = [];
  nameofstudent: any = [];
  nameofsem: any = [];
  nameoftest: any = [];
  loading = "none"
  ChildTestMappingId: string;
  students: any = [];
  SemesterData: any = [];
  YearData: any = [];
  TestData: any = [];
  SchoolDetailsaddress : any =[];
  NumberOfStudents: any = [];
  studentId: any = [];
  testId: any = [];
  sectionId: any = []
  guru: any = [];
  payload: any = [];
  public isEditable : Boolean = true;
  Marks: any = [];
  MaxMarks: any = [];
  today = new Date();
  Averages: any;
  schoolName :any;

  extractedContent: any;



  subjectsList: any = [];
  selectedSubject: any;
  selectedYear: any;
  selectedSemester: any;
  selectedTest: any;
  selectedPaperType: any;

  public isSuccessful: number = 0;
  public successOrErrorMsg: string = "";

  public grade: any = [];
  public selectedgrade:  any;
  public selectedsection:  any;

  public CurrentChild: any;
  public schoolLogo1 :string;
  public imgUrl1: string;
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public mappedData: any;
  public attachment;
  public Address: any;
  public City : any;
  public Pincode : any;
  public PrimaryPhonenumber : any;
  public WebsiteLink : any;
  public Email : any;
  public Logo : any;
  public RegNo :any;
  public userId :string;
  public childMapId : any = [];
  public TeacherNames : any = [];
  public EncodedLogo : any;
  public ShowLevelData: any;
  public selectedlevel: any;

  isLoading: boolean = false;
  errorMessage: string = '';
  displayErrorDialog: boolean = false;
  selectedLanguage: number;


  public typedText: string = '';
  private fullText: string = 'This is the text that will be typed!, Accessing well-structured question papers is crucial for students to excel in their academic pursuits. With carefully curated question papers, students gain the confidence to tackle examinations effectively, fostering a deeper understanding of subjects and enhancing their overall academic performance.';
  private currentIndex: number = 0;

  questionLanguage = [
    {name: 'English', id: 1},
    {name: 'Sinhala', id: 2},
    {name: 'Tamil', id: 3}
  ];

  constructor(private dataAnalyticsService: DataAnalyticsService, private router: Router, private noticeboardService: NoticeboardService, private appConstants: AppConstants, private localStorage: LocalStorageService, private messageService: MessageService) {

    // this.schoolName = this.localStorage.retrieve('schoolname');
    this.schoolLogo1 = this.localStorage.retrieve('Logo');
    this.imgUrl1 = this.appConstants.fileDownloadUrl;
    // this.attachment = this.imgUrl1 + this.Logo;
    this.userId = this.localStorage.retrieve('id');
  }

  ngOnInit() {

  }

  onSubmitClick() {
    const apiCode = '1CD9Vr4rLNK53-ONc9RYGCsjSM05an5nTqLktofLJus2AzFubeGWaQ==';

    if (!this.selectedFile) {
      console.error('No file selected');
      this.showErrorDialog("Please select a file");
      return;
    }

    let payload1 = { file: this.selectedFile };

    this.isLoading = true; // Start loading

    const timeoutId = setTimeout(() => {
      this.isLoading = false; // Stop loading on timeout
      this.messageService.add({
        severity: "error",
        summary: "Timeout",
        detail: "Sorry, something wrong with uploading the paper"
      });
      this.showErrorDialog("Something wrong with uploading the paper");
    }, 300000); // 1 minute timeout

    this.dataAnalyticsService.extractPdfFile(payload1, apiCode).subscribe(
      response => {
        clearTimeout(timeoutId); // Clear the timeout on successful response
        this.extractedContent = response.question_list;
        const contentJSONString = JSON.stringify(this.extractedContent);

        let payload = {
          AcademicYearId: this.selectedYear.YearId,
          LevelId: this.selectedlevel,
          GradeId: this.selectedGrade.standardId,
          SectionId: this.selectedSection.SectionId,
          SemesterId: this.selectedSemester.SemesterId,
          SubjectId: this.selectedSubject.SubjectId,
          UploadedBy: '',
          Content: contentJSONString,
          ExamId: this.selectedTest.TestId,
          PdfFile: this.selectedFile,
          QuestionPaperTypeId: this.selectedPaperType,
        };

        this.dataAnalyticsService.UploadPDFFile(payload).subscribe(
          response => {
            clearTimeout(timeoutId); // Clear the timeout on successful response
            this.isLoading = false; // Stop loading
            let res: any = response;
            if (res.Message === 'Question Paper added successfully.') {
              this.messageService.add({
                severity: "success",
                summary: "Talkative Parents",
                detail: "PDF File uploaded successfully",
              });
              this.isSuccessful = 1;
              this.successOrErrorMsg = res.Message;
              this.selectedYear = '';
              this.selectedlevel = '';
              this.selectedGrade = '';
              this.selectedSection = '';
              this.selectedSubject = '';
              this.selectedSemester = '';
              this.selectedTest = '';
              this.selectedPaperType = "All";
            } else {
              this.showErrorDialog(res.Data);
            }
          },
          error => {
            clearTimeout(timeoutId); // Clear the timeout on error
            this.isLoading = false; // Stop loading
            this.showErrorDialog(error.Data);
          }
        );
      },
      error => {
        clearTimeout(timeoutId); // Clear the timeout on error
        this.isLoading = false; // Stop loading
        this.showErrorDialog("Something wrong with uploading the paper");
      }
    );
  }



  showErrorDialog(message: string) {
    this.errorMessage = message;
    this.displayErrorDialog = true;
    this.isLoading = false;
    this.isSuccessful = 2;
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile);  // You can access the file here
    }
  }


  edit(){
    this.isEditable= false;
  }

  back(){
    this.previwbtn = true;
    this.printbtn = false;
  }

  preview() {
    // this.selectStyle = 'as';
    this.previwbtn = false;
    this.printbtn = true;
  }






}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/translate-papers/translate-papers.component.ts